import { faPlay } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import PlayBtn from '../../../../main/components/PlayBtn';
const QualifiedTmCard = ({ info }) => {
    return (
        <div className="col-md-4">
            <div className="tm-card d-flex ">
                <div className="d-flex  justify-content-between pe-3 pinter-cursor  secondary-text">
                    <p className="status">{info?.status}</p>
                    <PlayBtn link={info?.video_link} />
                </div>
                <div>
                    <h5>{info?.title1[0]?.text} </h5>
                    <p>{info?.description[0]?.text}</p>
                </div>
            </div>
        </div>
    );
};

export default QualifiedTmCard;